<template>
  <el-popover
    placement="top-start"
    width="500"
    trigger="hover">
    <slot name="reference" slot="reference"></slot>

    <!--<el-input prefix-icon="el-icon-search" clearable v-model="text" ref="text"></el-input>-->

    <div style="display: flex; margin: 16px 0 6px;">
      <div class="title">
        <div style="margin-left: 12px">服务顾问</div>
      </div>
      <div class="title">
        <div style="margin-left: 12px">技师</div>
      </div>
      <div class="title">
        <div style="margin-left: 12px">工组</div>
      </div>
    </div>

    <div style="border-bottom: 1px solid lightgrey"></div>
    <div style="display: flex; min-height: 200px; max-height: 360px;overflow: auto;">
      <div style="width: 150px">
        <radio-button-group v-model="$store.state.work.filters.consultantIds">
          <radio-button v-for="consultant of consultants || []"
                         :key="consultant.id"
                         :label="consultant.id"
                         :text="consultant.name"
                         style="width: 120px; margin-top: 4px"></radio-button>
        </radio-button-group>
      </div>
      <div style="width: 150px">
        <radio-button-group v-model="$store.state.work.filters.technicianIds">
          <radio-button v-for="tech of technicianList"
                         :key="tech.id"
                         :label="tech.id"
                         :text="tech.name"
                         style="width: 120px; margin-top: 4px;"></radio-button>
        </radio-button-group>
      </div>
      <div style="width: 160px">
        <radio-button-group v-model="$store.state.work.filters.teamIds">
          <radio-button v-for="team of $store.state.team.teamList"
                         :key="team.id"
                         :label="team.id"
                         :text="team.name"
                         style="width: 160px; margin-top: 4px;"></radio-button>
        </radio-button-group>
      </div>
    </div>
  </el-popover>
</template>

<script>
  import RadioButton from '@/views/wx/CheckButton'
  import { technicianList } from '@/utils/request'
  import RadioButtonGroup from '../../wx/CheckButtonGroup'

  export default {
    name: 'SearchPopover',
    components: {
      RadioButtonGroup,
      RadioButton
    },
    data () {
      return {
        technicianList: []
      }
    },
    created () {
      this.$store.dispatch('data/kvListForce', 'ConsultantsOfShop')
      technicianList().then(response => {
        this.technicianList = response.data
      })
      this.$store.dispatch('team/all')
    },
    methods: {
      // show () {
      //   this.$nextTick(() => {
      //     this.$refs.text.focus()
      //   })
      // }
    },
    computed: {
      consultants () {
        const ret = []
        for (const shop of this.$store.state.data.ConsultantsOfShop || []) {
          for (const consultant of shop.consultants || []) {
            ret.push(consultant)
          }
        }
        return ret
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    width: 150px;
    /*padding-left: 12px;*/
    font: bold 14px 'Microsoft YaHei';
    color: black;
  }
</style>
